import "./application.scss";
import "@hotwired/turbo-rails";

void import.meta.glob("./**/*_channel.js");

import "../controllers";

import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();
